var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 25.5L99 164.097L204 222V83.2411L100 25.5Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.623 91.0119L133 124.435L149.006 133.815L148.369 165L169 133.01C163.46 129.646 157.885 126.342 152.344 122.978C152.437 112.283 152.542 101.648 152.623 91V91.0119Z",
    fill: "#29A063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8772 173.327L30.856 188.457L94.0589 225.381L157.566 188.668L130.842 172.788",
    fill: "#FECECA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0738 112.36L51.7012 188.574L94.0473 212.932V121.53L78.0738 112.36Z",
    fill: "#FEE4E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.032 112.36L94.0471 121.53V212.932L136.182 188.574L110.032 112.36Z",
    fill: "#FEE4E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0737 112.36L94.0472 103.425L110.032 112.36L94.0472 121.53L78.0737 112.36Z",
    fill: "#FECECA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.874 127.385L94.0587 139.623V158.173L67.5457 142.785L72.874 127.385Z",
    fill: "#FECECA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.229 158.173L94.0588 176.055V194.827L56.8772 173.608L62.229 158.173Z",
    fill: "#FECECA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.185 127.385L94.0588 139.623V158.173L120.478 142.785L115.185 127.385Z",
    fill: "#FECECA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M125.76 158.173L94.0588 176.055V194.827L130.936 173.268L125.76 158.173Z",
    fill: "#FECECA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2111 234L30.856 197.837V188.457L94.0588 225.381L94.2111 234Z",
    fill: "#FEE4E2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.566 197.954V188.668L94.0588 225.381L94.2111 234L157.566 197.954Z",
    fill: "#F97E73"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.538 17.4999L100 25.4999L204.022 83.4999C209.352 80.8231 214.682 78.1345 220 75.4577C185.513 56.1424 151.014 36.827 116.526 17.4999H116.538Z",
    fill: "#29A063"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M219 211.323C213.996 214.878 208.993 218.445 204 222V83.5L220 75.5L219 211.335V211.323Z",
    fill: "#72D09A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109 36V54.3898L136 71C135.896 64.5956 135.78 58.2034 135.676 51.799C126.788 46.5327 117.9 41.2663 109 36Z",
    fill: "#29A063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditA);
export default __webpack_public_path__ + "static/media/auditA.52ca81c4c1a1e289df75d34d081c3083.svg";
export { ForwardRef as ReactComponent };